<script>
    const {title} = rpcjs.props;
    title.set('House | of | Ceek');
    import {houseceek} from './program_data.js';
    import HeaderProgramSection from './header_program_section.svelte';
    import Footer from '../landing_page/footer.svelte';
    const gifts = [
        {
            src: '/images/houseCeekPage/grandPrize.png',
            category: 'GRAND PRIZE',
            discription:
                '$50,000USD in cash and $50,000 equivalent in CEEK tokens and virtual land with prizes claimed by CEEK.',
        },
        {
            src: '/images/houseCeekPage/2nd.png',
            category: '2nd PRIZE',
            discription:
                '$25,000USD in cash and $25,000 equivalent in CEEK tokens and virtual land with prizes claimed by CEEK',
        },
        {
            src: '/images/houseCeekPage/3rd.png',
            category: '3rd PRIZE',
            discription:
                '$10,000USD in cash and $10,000 equivalent in CEEK tokens and virtual land with prizes claimed by CEEK.',
        },
    ];
</script>

<section>
    <HeaderProgramSection
        data={houseceek}
        marginTop="9.5vw"
        lineHeightMbl="11.111vw"
        TopMbl="105.5vw"
        textWidthMbl="77.4vw"
        colors="white"
        textWidth="62.5vw"
        headingTop="-8.4vw"
        headingLeft="0.135vw"
        hrWidth="33.929vw"
        hrTop="2.8vw"
        discTop="40vw"
        widthDescription="39.516vw"
        detailWidth="62.847vw"
        detailTop="47.427vw"
        MargintopMbl="158.411vw"
        detailmblWidth="86.273vw"
    />
    <div class="section1">
        <div class="number">
            <p>01</p>
        </div>
        <div class="logodiv">
            <div class="logo">
                <img
                    src="/images/houseCeekPage/logo.png"
                    alt=""
                    width="100%"
                    height="100%"
                />
            </div>
            <div class="text">
                <p>
                    DraperU is partnering with CEEK to find the top VR builders
                    & game developers.
                </p>
            </div>
        </div>
    </div>
    <div class="section2">
        <div class="applydiv">
            <div class="number">
                <p>02</p>
            </div>
            <div class="apply">
                <p>APPLY</p>
            </div>
        </div>
        <div class="graphicdiv">
            <div style="margin-top: 1.521vw;">
                <div class="maindiv">
                    <div class="image">
                        <img
                            src="/images/houseCeekPage/1.png"
                            alt=""
                            width="100%"
                            height="100%"
                        />
                    </div>
                    <div class="heading">
                        <h6>Submit your design</h6>
                        <p>
                            for the CEEK Metaverse. We are looking for music
                            venues, and incredible experiences for our guests.
                        </p>
                    </div>
                </div>
                <div class="maindiv">
                    <div class="image">
                        <img
                            src="/images/houseCeekPage/2.png"
                            alt=""
                            width="100%"
                            height="100%"
                        />
                    </div>
                    <div class="heading">
                        <h6 style="color:#035BA0 ;">20 winners</h6>
                        <p>
                            will be selected to join us in Silicon Valley! Stay
                            and build on campus at Draper University.
                        </p>
                    </div>
                </div>
                <div class="maindiv">
                    <div class="image">
                        <img
                            src="/images/houseCeekPage/3.png"
                            alt=""
                            width="100%"
                            height="100%"
                        />
                    </div>
                    <div class="heading">
                        <h6 style="color: #024579;">Top builders</h6>
                        <p>
                            Top builders will be awarded cash,<br /> tokens and virtual
                            land.
                        </p>
                    </div>
                </div>
            </div>
            <div class="graphicImg">
                <img
                    src="/images/houseCeekPage/Graphics.png"
                    alt=""
                    width="100%"
                    height="100%"
                />
            </div>
        </div>
    </div>
    <div class="bluediv">
        <p>
            for a 4-week in-residence program. It’s your opportunity to design
            and build valuable assets for the CEEK Metaverse for mutual benefit.
        </p>
    </div>
    <div class="desktop">
        <div class="section3">
            <div
                style="display: flex;align-items: baseline;margin-left:5.886vw;"
            >
                <div class="number">
                    <p>03</p>
                </div>
                <div class="WhyText">
                    <p>Why Join This Program</p>
                </div>
            </div>
            <div class="siliconImg">
                <img
                    src="/images/houseCeekPage/silicon.png"
                    alt=""
                    width="100%"
                    height="100%"
                />
            </div>
            <div class="siliconDisc" style="width: 55vw;margin:auto;">
                <p>
                    The top 20 applicants will have the opportunity to build for
                    the CEEK metaverse right in the heart of Silicon Valley at
                    DraperU. If your design makes it to the final top 3 you win
                    cash, tokens and virtual land.
                </p>
            </div>
            <div class="grandprizediv">
                <div class="dollordiv">
                    <div class="count">
                        <p>i</p>
                    </div>
                    <div class="stande" style="margin-left: 6.680vw;">
                        <img
                            src="/images/houseCeekPage/grandPrize.png"
                            alt=""
                            width="100%"
                            height="100%"
                        />
                    </div>
                    <div class="dollorhead">
                        <p>GRAND PRIZE</p>
                    </div>
                </div>
                <div class="siliconDisc" style="margin-top: 0.728vw;">
                    <p>
                        $50,000USD in cash and $50,000 equivalent in CEEK tokens
                        and virtual land with prizes claimed by CEEK.
                    </p>
                </div>
            </div>
            <div class="secondPrize">
                <div class="grandprizediv" style="margin: 1.786vw auto 0;">
                    <div class="dollordiv">
                        <div class="count">
                            <p>ii</p>
                        </div>
                        <div class="stande" style="margin-left: 6.680vw;">
                            <img
                                src="/images/houseCeekPage/2nd.png"
                                alt=""
                                width="100%"
                                height="100%"
                            />
                        </div>
                        <div class="dollorhead">
                            <p>2nd PRIZE</p>
                        </div>
                    </div>
                    <div class="siliconDisc" style="margin-top: 0.728vw;">
                        <p>
                            $25,000USD in cash and $25,000 equivalent in CEEK
                            tokens and virtual land with prizes claimed by CEEK
                        </p>
                    </div>
                </div>
                <div class="grandprizediv" style="margin: 1.786vw auto 0;">
                    <div class="dollordiv">
                        <div class="count">
                            <p>iii</p>
                        </div>
                        <div class="stande" style="margin-left: 6.680vw;">
                            <img
                                src="/images/houseCeekPage/3rd.png"
                                alt=""
                                width="100%"
                                height="100%"
                            />
                        </div>
                        <div class="dollorhead">
                            <p>3rd PRIZE</p>
                        </div>
                    </div>
                    <div class="siliconDisc" style="margin-top: 0.728vw;">
                        <p>
                            $10,000USD in cash and $10,000 equivalent in CEEK
                            tokens and virtual land with prizes claimed by CEEK.
                        </p>
                    </div>
                </div>
            </div>
            <div class="btnDiv" style="" on:click={()=>{
                location.href = '/applyProgram';
            }}>
                <button class="btn-css"> Apply today to win </button>
            </div>
        </div>
        <div class="descriptionDiv">
            <h6>TERMS & CONDITIONS:</h6>
            <p>
                First place prize is $50,000USD in cash and $50,000 equivalent
                in CEEK tokens and virtual land with prizes claimed by CEEK. The
                second place prize is $25,000USD in cash and $25,000 equivalent
                in CEEK tokens and virtual land with prizes claimed by CEEK. The
                third place prize is $10,000USD in cash and $10,000 equivalent
                in CEEK tokens and virtual land with prizes claimed by CEEK.
                Winning constitutes permission for CEEK to use the winner's
                designs within the CEEK metaverse and for future advertising,
                and publicity in any and all media now or hereafter devised
                throughout the world in perpetuity, without additional
                compensation, notification, or permission. Participants
                acknowledge that all work produced during the ‘House of CEEK’
                program shall become the sole and exclusive property of CEEK.
            </p>
        </div>
    </div>
    <div class="mobile">
        <div class="section3Mbl">
            <div style="display: flex;align-items: baseline;">
                <div class="number" style="margin-left: 7.710vw;">
                    <p>03</p>
                </div>
                <div class="WhyText">
                    <p>Why Join This Program</p>
                </div>
            </div>
            <div class="siliconImg">
                <img
                    src="/images/houseCeekPage/silicon.png"
                    alt=""
                    width="100%"
                    height="100%"
                />
            </div>
            <div class="siliconDisc" style="width: 83.178vw;margin:auto;">
                <p>
                    The top 20 applicants will have the opportunity to build for
                    the CEEK metaverse right in the heart of Silicon Valley at
                    DraperU. If your design makes it to the final top 3 you win
                    cash, tokens and virtual land.
                </p>
            </div>
            <div style="margin-top: 23.364vw;">
                {#each gifts as data}
                    <div class="grandprizediv">
                        <div class="dollordiv">
                            <div class="stande">
                                <img
                                    src={data.src}
                                    alt=""
                                    width="100%"
                                    height="100%"
                                />
                            </div>
                            <div class="dollorhead">
                                <p>{data.category}</p>
                            </div>
                        </div>
                        <div class="siliconDisc" style="margin-top: 6.308vw;">
                            <p>{data.discription}</p>
                        </div>
                    </div>
                {/each}
            </div>
            <div class="btnDiv" style=""  on:click={()=>{
                location.href = '/applyProgram';
            }}>
                <button class="btn-css"> Apply today to win </button>
            </div>
        </div>
    </div>
    <div>
        <Footer />
    </div>
</section>

<style>
    section {
        position: relative;
    }
    .section1 {
        position: absolute;
        left: 4.762vw;
        top: 63.585vw;
        display: flex;
    }
    p,
    h6 {
        margin: 0;
    }
    .logodiv {
        width: 93vw;
    }
    .number {
        font-size: 1.19vw;
        font-weight: 600;
        color: #00204b;
        opacity: 0.3;
    }
    .logo {
        width: 35.813vw;
        margin: auto;
    }
    .text {
        width: 63.562vw;
        margin: 2.2vw auto 0;
        text-align: center;
        font-size: 2.315vw;
        color: #00204b;
        line-height: 2.91vw;
        font-weight: 600;
    }
    .section2 {
        position: relative;
        top: 14.282vw;
        padding-left: 4.762vw;
    }
    .applydiv {
        display: flex;
    }
    .apply {
        font-weight: 700;
        font-size: 14.55vw;
        line-height: 12.235vw;
        color: rgba(124, 193, 255, 0.2);
        margin-left: 2.249vw;
    }
    .graphicdiv {
        display: flex;
    }
    .maindiv {
        display: flex;
    }
    .maindiv:nth-child(1) .image {
        width: 2.513vw;
        height: 5.423vw;
        margin: 0 5.423vw 0 4.696vw;
    }
    .maindiv:nth-child(2) .image {
        width: 4.233vw;
        height: 5.423vw;
        margin: 0 4.233vw 0 4.167vw;
    }
    .maindiv:nth-child(3) .image {
        width: 4.167vw;
        height: 5.423vw;
        margin: 0 4.762vw 0 4.365vw;
    }
    .heading {
        margin-bottom: 6.614vw;
    }
    .heading h6 {
        font-weight: 500;
        font-size: 1.984vw;
        line-height: 2.976vw;
        text-transform: uppercase;
        color: #4b9ad7;
    }
    .heading p {
        width: 21.693vw;
        font-weight: 300;
        font-size: 1.058vw;
        line-height: 1.257vw;
        color: #00204b;
        padding-top: 0.331vw;
    }
    .graphicImg {
        width: 60.614vw;
        height: 35.527vw;
    }
    .bluediv {
        margin-top: 23.979vw;
        background-color: #3c74c0;
        height: 16.336vw;
        position: relative;
    }
    .bluediv p {
        width: 79.503vw;
    font-weight: 700;
    font-size: 2.5vw;
        line-height: 3.307vw;
        text-align: center;
        text-transform: uppercase;
        color: #ffffff;
        margin: auto;
        padding-top: 3.241vw;
    }
    .bluediv::after {
        content: "";
        position: absolute;
        border: 0.2vw solid #f7e05f;
        transform: rotate(90deg);
        width: 10.053vw;
        top: -4vw;
        background-color: #f7e05f;
        border-radius: 5vw;
        left: 17vw;
    }
    .bluediv::before {
        content: "";
        position: absolute;
        border: 0.2vw solid #f7e05f;
        width: 1.389vw;
        background-color: #f7e05f;
        border-radius: 5vw;
        left: 11.5vw;
        bottom: 1.5vw;
    }
    .section3 {
        position: relative;
        margin-top: 9.59vw;
    }
    .WhyText {
        font-weight: 500;
        font-size: 2.067vw;
        line-height: 2.447vw;
        text-transform: uppercase;
        color: #7cc1ff;
        margin-left: 5.952vw;
    }
    .siliconImg {
        width: 39.138vw;
        height: 28.638vw;
        margin: auto;
    }
    .siliconDisc {
        
        font-weight: 400;
        font-size: 1.653vw;
        line-height: 2.315vw;
        text-align: center;
        color: #00204b;
    }
    .dollordiv {
        display: flex;
        align-items: end;
        margin-left: 1vw;
    }
    .count {
        font-weight: 700;
        font-size: 1.984vw;
        line-height: 4.63vw;
        color: #88bce6;
    }
    .stande {
        width: 9.458vw;
        height: 14.153vw;
    }
    .dollorhead {
        font-weight: 400;
        font-size: 2.05vw;
        line-height: 4.63vw;
        text-align: center;
        color: #00204b;
    }
    .grandprizediv {
        width: 39.418vw;
        margin: 7.804vw auto 0;
    }
    .secondPrize {
        display: flex;
        justify-content: space-between;
        width: 83.532vw;
        margin: auto;
    }
    .btnDiv {
        text-align: center;
        margin-top: 5vw;
    }
    .btn-css {
        background-color: #f7e05f;
        border-radius: 1.984vw;
        color: #00204b;
        font-weight: 500;
        border: none;
        width: 17.328vw;
        height: 3.638vw;
        font-size: 0.926vw;
        text-transform: uppercase;
    }
    .descriptionDiv {
        height: 32.209vw;
        background-color: #00204b;
        width: 100%;
        position: relative;
        top: 4.563vw;
    }
    .descriptionDiv h6 {
        font-weight: 400;
        font-size: 2.315vw;
        line-height: 2.315vw;
        text-align: center;
        color: #ffffff;
        padding: 6.68vw 0 1.521vw 0;
    }
    .descriptionDiv p {
        width: 88.161vw;
        font-weight: 400;
        font-size: 1.323vw;
        line-height: 2.315vw;
        text-align: center;
        color: #ffffff;
        margin: auto;
    }
    .desktop {
        display: block;
        position: relative;
    }
    .mobile {
        display: none;
        position: relative;
    }
    @media screen and (max-width: 1024px) {
        .desktop {
            display: none;
        }
        .mobile {
            display: block;
        }
        .section1 {
            left: 0;
            top: 266.121vw;
        }
        .number {
            font-size: 2.779vw;
            font-weight: 400;
            color: #00204b;
            opacity: 0.3;
            margin-left: 4.673vw;
            margin-top: 3vw;
        }
        .logodiv {
            width: 85vw;
        }
        .logo {
            width: 71.075vw;
            margin: auto;
        }
        .text {
            width: 81.428vw;
            margin: 6.745vw auto 0;
            text-align: center;
            font-size: 4.524vw;
            color: #00204b;
            line-height: 5.607vw;
        }
        .section2 {
            position: relative;
            margin-top: 29.39vw;
            padding-left: 4.673vw;
        }
        .applydiv {
            align-items: center;
        }
        .apply {
            font-weight: 700;
            font-size: 16.667vw;
            line-height: 16.355vw;
            color: rgba(124, 193, 255, 0.2);
            margin-left: 7.477vw;
        }
        .graphicdiv {
            display: block;
        }
        .maindiv:nth-child(1) .image {
            width: 6.542vw;
            height: 14.252vw;
            margin: 0 8.411vw 0 6.308vw;
        }
        .maindiv:nth-child(2) .image {
            width: 11.215vw;
            height: 14.252vw;
            margin: 0 5.14vw 0 4.907vw;
        }
        .maindiv:nth-child(3) .image {
            width: 10.981vw;
            height: 14.252vw;
            margin: 0 4.907vw 0 5.374vw;
        }
        .heading {
            margin-bottom: 11.916vw;
        }
        .heading h6 {
            font-weight: 500;
            font-size: 5.607vw;
            line-height: 6.514vw;
            text-transform: uppercase;
            color: #4b9ad7;
        }
        .heading p {
            width: 62.318vw;
            font-weight: 300;
            font-size: 3.738vw;
            line-height: 4.439vw;
            color: #00204b;
            padding-top: 3.568vw;
        }
        .graphicImg {
            width: 98.827vw;
            height: 55.643vw;
            margin: 7.009vw 0vw 0vw -8vw;
        }
        .bluediv {
            margin-top: 50.881vw;
            background-color: #3c74c0;
            height: 64.72vw;
            position: relative;
        }
        .bluediv p {
            width: 84.579vw;
            font-weight: 700;
            font-size: 5.558vw;
            line-height: 7.477vw;
            text-align: center;
            text-transform: uppercase;
            color: #ffffff;
            margin: auto;
            padding-top: 8.411vw;
        }
        .bluediv::after {
            content: "";
            position: absolute;
            border: 1vw solid #f7e05f;
            transform: rotate(90deg);
            width: 35.514vw;
            top: -14.5vw;
            background-color: #f7e05f;
            border-radius: 5vw;
            left: 1.2vw;
        }
        .bluediv::before {
            content: "";
            position: absolute;
            border: 1vw solid #f7e05f;
            width: 6.907vw;
            background-color: #f7e05f;
            border-radius: 5vw;
            left: 46.5vw;
            bottom: 7.5vw;
        }
        .WhyText {
            font-weight: 500;
            font-size: 5.549vw;
            line-height: 8.645vw;
            text-transform: uppercase;
            color: #7cc1ff;
            margin-left: 6.075vw;
        }
        .siliconImg {
            width: 82.243vw;
            height: 60.047vw;
            margin: 7.477vw auto 14.953vw;
        }
        .siliconDisc {
            font-weight: 300;
            font-size: 3.89vw;
            line-height: 6.114vw;
            text-align: center;
            color: #00204b;
        }
        .dollordiv {
            display: flex;
            align-items: end;
            margin-left: 1vw;
        }
        .stande {
            width: 24.329vw;
            height: 33.178vw;
        }
        .dollorhead {
            font-weight: 400;
            font-size: 5.558vw;
            line-height: 10.28vw;
            text-align: center;
            color: #00204b;
            margin-left: 1.605vw;
        }
        .grandprizediv {
            width: 87.85vw;
            margin: 0vw auto 7.044vw;
        }
        .btnDiv {
            text-align: center;
            margin-top: 11.682vw;
            margin-bottom: 34.346vw;
        }
        .btn-css {
            background-color: #f7e05f;
            border-radius: 8.333vw;
            color: #00204b;
            font-weight: 500;
            border: none;
            width: 46.262vw;
            height: 7.71vw;
            font-size: 3.333vw;
            text-transform: uppercase;
        }
    }
    .section3Mbl {
        position: relative;
        margin-top: 14.953vw;
    }
</style>
